/**
 * Kraftstoffberechnung (LBA P22–P27) and Masse-/Schwerpunkt (P28–P32).
 * Pure sums with the form's own semantics: minimum fuel is the sum of six
 * rows, extra is stock minus the EFFECTIVE minimum (a hand-corrected minimum
 * must flow through), safe flight time is max flight time minus 30 minutes.
 */
import { num, parseHM, fmtHM } from './parse.js';
export function computeFuel(f) {
    const parts = [f.reise, f.anlassen, f.steig, f.anab, f.altn, f.reserve].map(num);
    const some = parts.some(Number.isFinite);
    const sum = parts.reduce((a, b) => a + (Number.isFinite(b) ? b : 0), 0);
    const mindestL = some ? round1(sum) : null;
    const override = num(f.mindestOverride);
    const mindestEff = Number.isFinite(override) ? override : mindestL;
    const vorrat = num(f.vorrat);
    const extraL = Number.isFinite(vorrat) && mindestEff !== null ? round1(vorrat - mindestEff) : null;
    const maxT = parseHM(f.vorratZeit);
    const safeTime = Number.isFinite(maxT) ? fmtHM(Math.max(0, maxT - 30)) : null;
    return { mindestL, extraL, safeTime };
}
export function computeMass(x) {
    const col = (k) => {
        const g = (r) => num(r?.[k]);
        const leer = g(x.leer);
        const grund = Number.isFinite(leer)
            ? round1(leer + (Number.isFinite(g(x.kna)) ? g(x.kna) : 0) + (Number.isFinite(g(x.schmier)) ? g(x.schmier) : 0))
            : null;
        const grundOv = g(x.grundOverride);
        const grundEff = Number.isFinite(grundOv) ? grundOv : grund;
        let start = null;
        if (grundEff !== null) {
            let s = grundEff;
            for (const r of [x.sitz1, x.sitz2, x.sitz3, x.gepVorn, x.gepMitte, x.gepHinten, x.kausf]) {
                const v = g(r);
                if (Number.isFinite(v))
                    s += v;
            }
            start = round1(s);
        }
        return { grund, start };
    };
    const m = col('m'), mom = col('mom');
    return { grund: { m: m.grund, mom: mom.grund }, start: { m: m.start, mom: mom.start } };
}
const round1 = (v) => Math.round(v * 10) / 10;
//# sourceMappingURL=fuel.js.map